class Table {
    constructor(table, options) {
        this.table = table;
        this.options = options;
        let {
            rowData,
            columnDefs,
            headerCheckboxSelection,
            checkboxSelection,
            paginationList,
            pagination,
            paginationPageSize,
            rowIdField,
            getRowId,
            setRowNode,
            maxHeight,
            emptyText,
            isResponsive
        } = this.options;

        this.rowData = rowData || [];
        this.columnDefs = columnDefs || [];
        this.checkboxSelection = checkboxSelection || false;
        this.headerCheckboxSelection =
            headerCheckboxSelection ?? this.checkboxSelection;
        this.paginationList = paginationList || null;
        this.pagination = pagination || false;
        this.paginationPageSize = paginationPageSize || 100;

        this.rowIdField = rowIdField; // required
        this.getRowId = getRowId;
        this.setRowNode = setRowNode || null;
        this.maxHeight = maxHeight || null;
        this.emptyText = emptyText || 'No rows to show'
        
        this.isResponsive = isResponsive || false;


        this.startIndex = 0;
        this.endIndex = 0;
        this.currentPage = 1;

        this.selectedRows = new Map();

        this.setup();
    }

    setup() {
        if (!this.rowData?.length) {
            this.renderNoData();
            return;
        }

        if (this.pagination && this.paginationPageSize) {
            if (this.paginationPageSize > this.rowData.length) {
                this.paginationPageSize = this.rowData.length;
            }
            this.endIndex = this.paginationPageSize;
        } else {
            this.endIndex = this.rowData.length;
        }

        this.createTable(this.rowData);

        if (this.pagination) {
            if (this.paginationList) {
                this.createPagination();
            }
        } else {
            if (this.paginationList) {
                this.paginationList.remove();
            }
        }
    }

    autoHeight() {
        let headRowHeight = this.table.querySelector("thead > tr")?.offsetHeight || 0;
        let bodyRowHeight = 0;
        this.table.querySelectorAll("tbody > tr").forEach((e) => {
            bodyRowHeight += e.offsetHeight;
        });

        // let height = (bodyRowHeight * this.paginationPageSize) + headRowHeight;
        let height =
            Math.ceil(bodyRowHeight / this.paginationPageSize) *
            this.paginationPageSize +
            headRowHeight;
        
        this.table.style.height = `${height}px`;
        if (this.maxHeight) {
            this.table.style.maxHeight = this.maxHeight;
        }
    }

    renderNoData() {
        this.table.style = "display: block";
        this.table.innerHTML = `
        <div class="message">
            ${this.emptyText}
        </div>
        `;

        this.paginationList.style = 'display: none'

    }

    createTable(data) {
        this.flush();

        // if(!refresh){
        //     this.rowData = data;
        // }

        if (this.checkboxSelection) {
            const id = `${this.table.id}_header-checkbox`;
            const theadRow = this.table.querySelector("thead > tr");
            if(!theadRow) return;
            
            const thCheckbox = theadRow.querySelector(`#${id}`);
            if (!thCheckbox) {
                let th = document.createElement("th");
                th.className = "th-checkbox cell-right";
                th.id = id;
                if (this.headerCheckboxSelection) {
                    let inputEle = document.createElement("input");
                    inputEle.type = "checkbox";
                    inputEle.addEventListener(
                        "change",
                        this.handleHeaderCheckbox.bind(this)
                    );
                    th.appendChild(inputEle);
                }
                // checkboxInput.addEventListener("change", this.selectAll.bind(this));

                theadRow.insertBefore(th, theadRow.firstChild);
            }
        }

        const tbody = document.createElement("tbody");
        for (let index = this.startIndex; index < this.endIndex; index++) {
            const rowData = data[index];
            if (!rowData) continue;
            const row = this.createRow(rowData);
            const rowId = this.getRowId(rowData);

            row.id = rowId;
            row.setAttribute('data-id', rowId);
            // row.id = this.rowIdField ? rowData[this.rowIdField] : `${this.table.id}_${index}`

            if (this.setRowNode) {
                this.setRowNode({ data: rowData, node: row });
            }

            // this.rowData.set(rowId, rowData);

            tbody.appendChild(row);
            if(this.isResponsive){
                const card = this.createCard(rowData);
                card.id = rowId;
                card.setAttribute('data-id', rowId);
                tbody.appendChild(card);
            }
        }

        
        this.table.appendChild(tbody);

        setTimeout(() => {
            this.autoHeight();
        }, 500);
    }

    createRow(rowData) {
        const tr = document.createElement("tr");
        tr.className = 'table-row'

        for (let index = 0; index < this.columnDefs.length; index++) {
            const columnDef = this.columnDefs[index];
            const { field, cellRender, className } = columnDef;
            let td = document.createElement("td");
            const value = rowData[field] || "";

            if (cellRender) {
                let node = cellRender(rowData);
                if (typeof node === "object") {
                    td.appendChild(node);
                } else if (typeof node === "string") {
                    td.innerHTML = node;
                } else {
                    td.innerHTML = "";
                }
            } else {
                let textNode = document.createTextNode(rowData[field] || "");
                td.appendChild(textNode);
            }

            if (className) {
                td.className = className;
            }

            tr.appendChild(td);
        }

        if (this.checkboxSelection) {
            const td = document.createElement("td");
            const inputEle = document.createElement("input");
            inputEle.type = "checkbox";
            inputEle.addEventListener("change", this.handleCheckbox.bind(this));

            td.className = "td-checkbox cell-right";
            td.appendChild(inputEle);

            tr.insertBefore(td, tr.firstChild);
        }

        return tr;
    }

    createColumn(key, value) {
        const columnDef = this.columnDefs.find(({ field }) => field === key);
        let td = document.createElement("td");
        if (columnDef) {
            td.appendChild(document.createTextNode(value));
        } else {
        }
        return td;
    }

    createCard(rowData){
        let tr = document.createElement("tr");
        tr.className = 'card-row'
        
        const td = document.createElement("td");
        td.className = "table-card"

        let cardItem1 = document.createElement("div");
        cardItem1.className = 'table-card-item table-content';
        let cardItem2 = document.createElement("div");
        cardItem2.className = 'table-card-item';

        if (this.checkboxSelection) {
            const inputEle = document.createElement("input");
            inputEle.type = "checkbox";
            inputEle.addEventListener("change", this.handleCheckbox.bind(this));
            let div = document.createElement("div");

            div.className = "td-checkbox";
            
            div.appendChild(inputEle);
            td.appendChild(div);
        }

        cardItem1.innerHTML = `
            <div class="thumbnail">
            ${createElement("image", this.columnDefs, rowData).innerHTML}
            </div>

            <div>
                ${createElement("title", this.columnDefs, rowData).innerHTML}
                <div>${createElement("price", this.columnDefs, rowData).innerHTML}</div>
            </div>
        `

        cardItem2.appendChild(createElement("order", this.columnDefs, rowData).lastChild)

        td.appendChild(cardItem1);
        td.appendChild(cardItem2);

        
        tr.appendChild(td);

        function createElement(key, columnDefs, rowData) {
            const columnDef = columnDefs.find(({ field }) => field === key);
            const { field, cellRender, className } = columnDef;

            let element = document.createElement("div");

            if (cellRender) {
                // let div = document.createElement('div');
                let node = cellRender(rowData);
                if (typeof node === "object") {
                    element.appendChild(node);
                } else if (typeof node === "string") {
                    element.innerHTML = node;
                } else {
                    element.innerHTML = "";
                }
            } else {
                let textNode = document.createTextNode(rowData[field] || "");
                element.appendChild(textNode);
            }

            return element;
        }

        return tr;

    }

    deleteRow(rowId) {
        // rowId = this.getRowId({[this.rowIdField]: rowId})
        this.table.querySelectorAll(`[data-id="${rowId}"]`).forEach((row) => {
            
            row.style.opacity = "0";
            // row.ontransitionend = () => {
                row.remove();
                // this.refresh()
                let rowData = [...this.rowData];
                rowData = rowData.filter(
                    (e) =>
                        this.getRowId({ [this.rowIdField]: e[this.rowIdField] }) !== rowId
                );
                
                this.rowData = rowData;
                // };
        });
        this.setup();
    }

    createPagination() {
        this.totalRows = this.rowData.length;
        this.pageSize = Math.ceil(this.totalRows / this.paginationPageSize);

        let prevBtn = this.paginationList.querySelector(".js-paginate-prev");
        let nextBtn = this.paginationList.querySelector(".js-paginate-next");

        prevBtn.addEventListener("click", this.handlePrevious.bind(this));
        nextBtn.addEventListener("click", this.handleNext.bind(this));

        let pageList = this.paginationList.querySelectorAll("li.page-list");
        if (pageList.length) {
            pageList.forEach((e) => e.remove());
        }

        for (let page = 1; page <= this.pageSize; page++) {
            let li = document.createElement("li");
            li.className = "page-list";
            li.setAttribute("data-value", page);
            li.appendChild(document.createTextNode(`${page}`));
            li.addEventListener("click", this.handlePage.bind(this));
            this.paginationList.insertBefore(li, nextBtn);
        }

        let currentPage = this.paginationList.dataset?.currentPage || 1;
        currentPage = parseInt(currentPage, 10);

        this.currentPage = currentPage || 1;

        this.paginationList
            .querySelector(`li.page-list[data-value="${currentPage}"]`)
            .classList.add("active");

        if (this.currentPage <= 1) {
            prevBtn.classList.add("disabled");
        }
    }

    updateTable(data) {
        this.createTable(data);
    }

    refresh() {
        this.createTable(this.rowData);
    }

    handlePrevious(event) {
        let prevPageNumber = this.currentPage - 1;
        if (prevPageNumber <= 0) {
            event.target.classList.add("disabled");
        } else {
            let pageList = this.paginationList.querySelector(
                `li.page-list[data-value="${prevPageNumber}"]`
            );

            this.rotatePage(prevPageNumber, pageList);
        }
    }

    handleNext(event) {
        let prevPageNumber = this.currentPage + 1;
        
        if (prevPageNumber > this.pageSize) {
            event.target.classList.add("disabled");
        } else {
            let pageList = this.paginationList.querySelector(
                `li.page-list[data-value="${prevPageNumber}"]`
            );

            this.rotatePage(prevPageNumber, pageList);
        }
    }

    handlePage(event) {
        let pageNumber = event.target.dataset.value;
        pageNumber = parseInt(pageNumber, 10);

        this.rotatePage(pageNumber, event.target);

        // this.paginationList.querySelectorAll('li.page-list').forEach(e => e.classList.remove('active'));
        // event.target.classList.add('active');
    }

    rotatePage(pageNumber, pageList) {
        this.currentPage = pageNumber;
        let [startIndex, endIndex] = this.getPageIndex(pageNumber);
        this.startIndex = startIndex;
        this.endIndex = endIndex <= this.totalRows ? endIndex : this.totalRows;

        this.paginationList.setAttribute("data-current-page", this.currentPage);

        this.paginationList
            .querySelectorAll("li.page-list")
            .forEach((e) => e.classList.remove("active"));
        pageList.classList.add("active");

        let prevBtn = this.paginationList.querySelector(".js-paginate-prev");
        let nextBtn = this.paginationList.querySelector(".js-paginate-next");
        if (this.currentPage === this.pageSize) {
            nextBtn.classList.add("disabled");
        } else if (this.currentPage <= 1) {
            prevBtn.classList.add("disabled");
        } else {
            nextBtn.classList.remove("disabled");
            prevBtn.classList.remove("disabled");
        }

        this.refresh();
    }

    getPageIndex(page_number) {
        return [
            (page_number - 1) * this.paginationPageSize,
            page_number * this.paginationPageSize,
        ];
    }

    paginate(array, page_size, page_number) {
        // human-readable page numbers usually start with 1, so we reduce 1 in the first argument
        return array.slice((page_number - 1) * page_size, page_number * page_size);
    }

    handleHeaderCheckbox(event) {
        let checked = event.target.checked;
        this.table
            .querySelectorAll(".td-checkbox > input[type=checkbox]")
            .forEach((element) => {
                element.checked = checked;
                const event = new Event('change', { bubbles: true });
                element.dispatchEvent(event)
            });
        // if (checked) {
        //     this.selectedRows = new Map(
        //         this.rowData.map((r) => [r[this.rowIdField], r])
        //     );
        // } else {
        //     this.selectedRows = new Map();
        // }
    }

    setSelect(id, checked){
        this.table
        .querySelectorAll(`[data-id="${id}"]`)
        .forEach((element) => {
            let checkbox = element.querySelector(".td-checkbox > input[type=checkbox]")
            checkbox.checked = checked;
            const event = new Event('change', { bubbles: true });
            checkbox.dispatchEvent(event)
        });
    }

    selectAll(checked){
        this.table
        .querySelectorAll(".td-checkbox > input[type=checkbox]")
        .forEach((element) => {
            element.checked = checked;
            const event = new Event('change', { bubbles: true });
            element.dispatchEvent(event)
        });
    }

    handleCheckbox(event) {
        const checked = event.target.checked;
        const parentNode = event.target.closest("tr");
        if (checked) {
            let selectedRow = this.rowData.find(
                (row) =>  this.getRowId(row) === parentNode.id
            );
            this.selectedRows.set(parentNode.id, selectedRow);
        } else {
            this.selectedRows.delete(parentNode.id);
        }
    }

    getSelectedRows() {
        return this.selectedRows.size > 0 ? Array.from(this.selectedRows, ([_, v]) => v) : [];
    }

    flush() {
        let tbody = this.table.querySelector("tbody");
        if (tbody) {
            tbody.remove();
        }
    }
}
